import React from 'react';

import { Card } from 'primereact/card';
import { ScrollPanel } from 'primereact/scrollpanel';

type TagsFrameProps = {
  height?: number;
  emptyText?: string;
  isEmpty?: boolean;
  children: React.ReactNode;
};

const TagsFrame: React.FC<TagsFrameProps> = ({
  height = 150,
  emptyText,
  isEmpty,
  children
}) => {
  return (
    <Card style={{ width: '100%', height: height + 35, color: '#6c757d' }}>
      <ScrollPanel style={{ width: '100%', height }}>
        {isEmpty && emptyText ? <p>{emptyText}</p> : null}
        {children}
      </ScrollPanel>
    </Card>
  );
};

export default React.memo(TagsFrame);

